import { render, staticRenderFns } from "./MetadadosCampoDinamicoPercentual.vue?vue&type=template&id=47185426"
import script from "./MetadadosCampoDinamicoPercentual.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoPercentual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports